// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Rs7M0","content":"styles_content__VIN5q","title":"styles_title__C27Hn"};